var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.3335 14.6666H14.6668",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 2.66671V14.6667H9.5V2.66671C9.5 1.93337 9.2 1.33337 8.3 1.33337H7.7C6.8 1.33337 6.5 1.93337 6.5 2.66671Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2 6.66671V14.6667H4.66667V6.66671C4.66667 5.93337 4.4 5.33337 3.6 5.33337H3.06667C2.26667 5.33337 2 5.93337 2 6.66671Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.3335 9.99996V14.6666H14.0002V9.99996C14.0002 9.26663 13.7335 8.66663 12.9335 8.66663H12.4002C11.6002 8.66663 11.3335 9.26663 11.3335 9.99996Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.f53812e815f79a65f706f913b9ba0bb2.svg";
export { ForwardRef as ReactComponent };